/** The connection light. Small, honest, and always visible somewhere. */

import type { Status } from '../net/connection.js';

export function Pip({ status, rtt }: { status: Status; rtt: number }) {
  const tone = status !== 'open' ? 'bad' : rtt > 220 ? 'warn' : '';
  const text =
    status === 'open'
      ? rtt
        ? `On the wire · ${rtt} ms`
        : 'On the wire'
      : status === 'connecting'
        ? 'Knocking…'
        : 'Line is down — retrying';
  return (
    <span className={`pip ${tone}`} role="status" aria-live="polite">
      <span className="dot" aria-hidden="true" />
      {text}
    </span>
  );
}
